import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@walmart-web/livingdesign-components';

function ShimmerLineChart() {
	const useStyles = makeStyles(() => ({
		chartContainer: {
			padding: '12px 16px 20.5px',
			marginTop: '1px',
			borderRadius: '8px',
		},

		menuChip: {
			border: 'none',
			margin: '8px',
		},

		loadingTabContainer: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'flex-start',
			gap: '16px',
		},

		loadingTabItem: {
			display: 'flex',
			alignItems: 'center',
		},

		loadingMenu: {
			margin: '26.5px 0 45.5px',
		},

		loadingChartGridLineContainer: {
			marginTop: '29.5px',
		},

		loadingChartGridLine: {
			borderBottom: '1px #e6e6e6 solid',
			marginLeft: '36px',
		},

		loadingXAxis: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-around',
			marginTop: '8.5px',
		},

		loadingLegend: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'center',
			alignItems: 'center',
			gap: '28px',
			marginTop: '30px',
		},

		loadingLegendItem: {
			display: 'flex',
			flexDirection: 'row',
			gap: '8px',
		},
	}));

	const classes = useStyles();

	return (
		<>
			<div className={classes.chartContainer}>
				{/* Loading Tab */}
				<div className={classes.loadingTabContainer}>
					<div className={classes.loadingTabItem}>
						<Skeleton height="17.5px" width="129px" variant="rounded" />
					</div>
				</div>

				{/* Loading MenuList */}
				<div className={classes.loadingMenu}>
					<Skeleton height="10.5px" width="213px" variant="rounded" />
				</div>

				{/* Loading Chart */}
				<div>
					<div className={classes.loadingChartGridLineContainer}>
						<Skeleton height="10.5px" width="22px" variant="rounded" />
					</div>
					<div className={classes.loadingChartGridLine}></div>

					<div className={classes.loadingChartGridLineContainer}>
						<Skeleton height="10.5px" width="29px" variant="rounded" />
					</div>
					<div className={classes.loadingChartGridLine}></div>

					<div className={classes.loadingChartGridLineContainer}>
						<Skeleton height="10.5px" width="31px" variant="rounded" />
					</div>
					<div className={classes.loadingChartGridLine}></div>

					<div className={classes.loadingChartGridLineContainer}>
						<Skeleton height="10.5px" width="17px" variant="rounded" />
					</div>
					<div className={classes.loadingChartGridLine}></div>

					<div className={classes.loadingChartGridLineContainer}>
						<Skeleton height="10.5px" width="18px" variant="rounded" />
					</div>
					<div className={classes.loadingChartGridLine}></div>

					<div className={classes.loadingChartGridLineContainer}>
						<Skeleton height="10.5px" width="21px" variant="rounded" />
					</div>
					<div className={classes.loadingChartGridLine}></div>
				</div>

				{/* Loading X Axis */}
				<div className={classes.loadingXAxis}>
					<Skeleton height="10.5px" width="25px" variant="rounded" />
					<Skeleton height="10.5px" width="20px" variant="rounded" />
					<Skeleton height="10.5px" width="16px" variant="rounded" />
					<Skeleton height="10.5px" width="25px" variant="rounded" />
					<Skeleton height="10.5px" width="25px" variant="rounded" />
				</div>

				{/* Loading Legend */}
				<div className={classes.loadingLegend}>
					<div className={classes.loadingLegendItem}>
						<Skeleton height="8px" width="24px" variant="rectangle" />
						<Skeleton height="10.5px" width="36px" variant="rounded" />
					</div>

					<div className={classes.loadingLegendItem}>
						<Skeleton height="8px" width="24px" variant="rectangle" />
						<Skeleton height="10.5px" width="73px" variant="rounded" />
					</div>
				</div>
			</div>
		</>
	);
}

export default ShimmerLineChart;
